import React from 'react';
import * as S from './LocationPoints.styles';
import CustomRadioButton from '../../../../../../../src/stories/core-components/RadioButton/RadioButton';

type LocationProps = {
  time?: string;
  location?: string;
  address?: string;
  isSelection?: boolean;
  onClick?: any;
  isActive?:boolean;
};

// add className='active' on listItem tag only when user selects
const LocationBox = (props: LocationProps) =>{ 
  const {time, location, address, isSelection = true,isActive,onClick} = props;
  return(
  <S.listItem className={`${isActive ? 'active':''}`} style={{cursor:isSelection ? 'pointer':''}} onClick={onClick}>
    {(isSelection && <CustomRadioButton isActive={isActive}/>) || ''}
    <S.listContent>
      <p className="time">{time}</p>
      <p className="location">{location}</p>
      <p className="address">{address}</p>
    </S.listContent>
  </S.listItem>
);}
export default LocationBox;
